function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/RangeSlider',['iScroll'], function (IScroll) {
  'use strict';

  /**
   * RangeSlider class.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @jira CHEF-220
   * 
   * @created 2021-02-26
   * 
   * @type RangeSlider
   */
  var RangeSlider = /*#__PURE__*/_createClass(
  /**
   * Constructor.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @created 2021-02-26
   * 
   * @returns {undefined}
   */
  function RangeSlider() {
    var _this = this;
    _classCallCheck(this, RangeSlider);
    /**
     * Init.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "init", function () {
      _this.setupRangeInput();
      return _this;
    });
    /**
     * Setup the range input slider.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "setupRangeInput", function () {
      var $sliderUserVal = _this.$slide.find(_this.o.sel.sliderUserVal);

      /* Events during sliding. */
      _this.$rangeInput.on('input', function (oEvent) {
        _this.setImages(_this.$rangeInput.val());
        _this.$sliderUserBullet.css('left', _this.$rangeInput.val() + '%');
        $sliderUserVal.html(_this.$rangeInput.val());
      });

      /* Event after sliding. */
      _this.$rangeInput.on('mouseup touchend', function (oEvent) {
        if (false === _this.$rangeInput.hasClass(_this.o.opts.classes.disabled)) {
          _this.$rangeInput.attr(_this.o.opts.attr.disabled, true);
          _this.$rangeInput.addClass(_this.o.opts.classes.disabled);
          _this.displayResults(_this.$rangeInput.val());
        }
      });
    });
    /**
     * Set the images.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @param {int} iValue
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "setImages", function (iValue) {
      var $imageContainers = _this.$slide.find(_this.o.sel.feedbackImg);
      $imageContainers.each(function (iIndex, oElement) {
        /* Change at 54% instead of at 50%. */
        if (iIndex >= (iValue - 4) / 10) {
          $(oElement).addClass(_this.o.opts.classes.man);
          $(oElement).removeClass(_this.o.opts.classes.woman);
        } else {
          $(oElement).addClass(_this.o.opts.classes.woman);
          $(oElement).removeClass(_this.o.opts.classes.man);
        }
      });
    });
    /**
     * Display the results.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * @udpated 2021-03-10
     * 
     * @param {int} iValue
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "displayResults", function (iValue) {
      /* Deactivate scrolling. */
      window.fullpage.setAllowScrolling(false);
      window.fullpage.setKeyboardScrolling(false);
      var $resultModal = $(_this.o.sel.resultModal);
      $resultModal.on('touchmove', function (oEvent) {
        oEvent.preventDefault();
      });
      var oIScroll = new IScroll($resultModal.find(_this.o.sel.modalContent).get(0), {
        mouseWheel: true,
        scrollbars: true,
        scrollX: false,
        scrollY: true,
        bounce: false,
        probeType: 0
      });

      /* Between 30-40% show correct message. */
      if (30 <= iValue && 40 >= iValue) {
        $resultModal.find(_this.o.sel.correct).removeClass(_this.o.opts.classes.hide);
      } else {
        $resultModal.find(_this.o.sel.incorrect).removeClass(_this.o.opts.classes.hide);
      }

      /* Show result stuff. */
      $(_this.o.sel.showOnResults).removeClass(_this.o.opts.classes.hide);

      /* Hide other stuff. */
      $(_this.o.sel.hideOnResults).addClass(_this.o.opts.classes.hide);

      /* Setup the bars. */
      var $bars = _this.$slide.find(_this.o.sel.bar);
      $bars.each(function (iIndex, oElement) {
        var $element = $(oElement);

        /* Display the caption. */
        $element.find(_this.o.sel.barCaption).removeClass(_this.o.opts.classes.hide);

        /* Setup animation. */
        _this.oTimeline.to(oElement, {
          width: $element.data(_this.o.opts.data.val) + '%',
          duration: 1,
          delay: iIndex === 0 ? 0 : -0.7,
          ease: 'ease-in',
          onComplete: function onComplete() {
            /* Display the %. */
            $element.find(_this.o.sel.barCaptionRight).addClass(_this.o.opts.classes.show);
          }
        });
      });

      /* Show result modal. */
      _this.showResultModal();

      /* Add close-listener. */
      $(_this.o.sel.resultModalClose).on('click', function (oEvent) {
        _this.onResultModalClose();
      });
      window.fullpage.reBuild();
    });
    /**
     * Show the result overlay.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "showResultModal", function () {
      var $modal = $(_this.o.sel.resultModal);
      var $modalOverlay = $modal.find(_this.o.sel.modalOverlay);
      $modal.addClass('open');
      $modalOverlay.addClass('show');
    });
    /**
     * On result modal close play timeline.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "onResultModalClose", function () {
      _this.oTimeline.play();
    });
    /**
     * Callback on timeline complete.
     * Animate input thumb to correct position.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "onTimelineComplete", function () {
      _this.$sliderUserBullet.removeClass(_this.o.opts.classes.hide);
      var iValue = _this.$rangeInput.val();
      var oInterval = setInterval(function () {
        if (32 < iValue) {
          iValue--;
        } else {
          iValue++;
        }
        _this.$rangeInput.val(iValue);
        if (32 === iValue) {
          clearInterval(oInterval);
        }
      }, 20);
    });
    this.o = {
      sel: {
        slide: '#s22-1',
        rangeInput: '.range-slider',
        feedbackImg: '.slider-feedback-img',
        sliderUserVal: '.slider-user-val',
        resultModalClose: '#s22-1-modal-m2 .modal-close, #s22-1-modal-m2 .modal-overlay',
        modal: '#s22-1-modal-m1',
        resultModal: '#s22-1-modal-m2',
        incorrect: '.fdb-incorrect',
        correct: '.fdb-correct',
        hideOnResults: '.hide-for-fdb',
        showOnResults: '.show-for-fdb',
        bar: '.bar',
        barCaption: '.bar-caption',
        barCaptionRight: '.bar-caption-right',
        sliderUserBullet: '.slider-user-val-bullet',
        modalContent: '.modal-content'
      },
      opts: {
        classes: {
          hide: 'hide',
          man: 'man',
          woman: 'woman',
          open: 'open',
          show: 'show',
          disabled: 'disabled'
        },
        data: {
          val: 'val'
        },
        attr: {
          disabled: 'disabled'
        }
      }
    };
    this.$slide = $(this.o.sel.slide);
    if (this.$slide) {
      this.oTimeline = gsap.timeline({
        paused: true,
        onComplete: this.onTimelineComplete
      });
      this.$rangeInput = this.$slide.find(this.o.sel.rangeInput);
      this.$sliderUserBullet = this.$slide.find(this.o.sel.sliderUserBullet);
      this.init();
    }
  });
  return RangeSlider;
});

